import { GET_LOGIN } from "redux/actions/auth";
import {
  GET_DETAIL_JOBDESC,
  GET_LIST_VERSIONID,
  GET_LIST_JOBDESC,
  GET_LIST_JOBDESC_LIMIT,
  GET_ORG_STRUCTURE_JOBDESC,
  GET_MAINRESPO_JOBDESC,
  GET_KPI_JOBDESC,
  GET_AUTHORITY_JOBDESC,
  GET_WORK_RELATION_JOBDESC,
  GET_DETAIL_JOBDESC_V2
} from "redux/actions/jobdesc";

const initialState = {
  list: [],
  list_jobdesc_limit: [],
  total_jobdesc_limit: null,
  detail: null,
  jobdesc_view_structure: [],
  jobdesc_view_kpi: [],
  jobdesc_view_main_respo: [],
  jobdesc_view_work_relation: [],
  jobdesc_view_authority: [],
  jobdesc_view_detailV2: []
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_LIST_JOBDESC: {
      return {
        ...state,
        list: payload
      };
    }
    case GET_LIST_VERSIONID: {
      return {
        ...state,
        version: payload
      };
    }
    case GET_DETAIL_JOBDESC: {

      if (payload.reset) {
        return {
          ...state,
          detail: null
        };
      }
      return {
        ...state,
        detail: {
          ...payload,
          struktur_organisasi: payload.struktur_organisasi.map(val => ({
            "Organization ID": val.organization_id,
            Nama: val.name,
            Tag: val.tag,
            tags: val.job_level,
            "Job Grade": val.job_grade,
            Purpose: val.purpose,
            "Report to": val.report_to_id,
            "Job Level": val.job_level,
            subordinate: val.subordinate
          }))
        }
      };
    }
    case GET_LIST_JOBDESC_LIMIT: {
      return {
        ...state,
        list_jobdesc_limit: payload.data,
        total_jobdesc_limit: payload.count
      };
    }
    case GET_ORG_STRUCTURE_JOBDESC: {
      return {
        ...state,
        jobdesc_view_structure: payload.data
      };
    }
    case GET_MAINRESPO_JOBDESC: {
      return {
        ...state,
        jobdesc_view_main_respo: payload.data
      };
    }
    case GET_KPI_JOBDESC: {
      return {
        ...state,
        jobdesc_view_kpi: payload.data
      };
    }
    case GET_AUTHORITY_JOBDESC: {
      return {
        ...state,
        jobdesc_view_authority: payload.data
      };
    }
    case GET_WORK_RELATION_JOBDESC: {
      return {
        ...state,
        jobdesc_view_work_relation: payload.data
      };
    }
    case GET_DETAIL_JOBDESC_V2: {
      return {
        ...state,
        jobdesc_view_detailV2: payload.data
      };
    }

    default:
      return state;
  }
};
